import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, DispatchProp } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { deleteConversations } from 'src/redux/catalog/catalog-slice';
import { Conversation } from 'src/types/conversation';
import { Catalog } from 'src/types/insights';
import ConversationAutocomplete from './ConversationAutocomplete';

interface BaseProps {
  catalog: Catalog;
  closeDialog: () => void;
  conversations: Conversation[];
  open: boolean;
}

type Props = BaseProps & DispatchProp;

const DeleteConversationsDialog: React.FunctionComponent<Props> = (
  props: Props
) => {
  const { catalog, closeDialog, conversations, dispatch, open } = props;
  const { t } = useTranslation();

  const [selectedConversations, setSelectedConversations] =
    React.useState(conversations);

  React.useEffect(() => {
    setSelectedConversations([]);
  }, [open]);

  const handleSubmit = () => {
    const request: [Catalog['id'], Conversation['id'][]] = [
      catalog.id,
      selectedConversations.map((conversation) => conversation.id),
    ];
    closeDialog();
    dispatch(deleteConversations(request));
  };

  return (
    <Dialog
      data-testid="DeleteConversationsDialog"
      disableRestoreFocus
      onClose={closeDialog}
      open={open}
    >
      <DialogTitle>{t('insights.remove_highlights')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('insights.delete_conversation_description')}
        </DialogContentText>
        <ConversationAutocomplete
          conversationOptions={conversations}
          initialConversations={[]}
          organizationId={catalog.organization_id}
          selectedConversations={selectedConversations}
          setSelectedConversations={setSelectedConversations}
        />
      </DialogContent>
      <DialogActions>
        <Button data-testid="delete-dialog-cancel-button" onClick={closeDialog}>
          {t('common.cancel')}
        </Button>
        <Button onClick={handleSubmit}>{t('common.submit')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect()(DeleteConversationsDialog);
